import { NavLink } from "react-router-dom";
import { Home, BookOpen, ScanLine, Camera, Menu } from "lucide-react";

const items = [
  { to: "/event", icon: Home, label: "Home", testid: "bottom-nav-home", end: true },
  { to: "/event/program", icon: BookOpen, label: "Program", testid: "bottom-nav-program" },
  { to: "/event/checkin", icon: ScanLine, label: "Check In", testid: "bottom-nav-checkin", primary: true },
  { to: "/event/photos", icon: Camera, label: "Photos", testid: "bottom-nav-photos" },
  { to: "/event/more", icon: Menu, label: "More", testid: "bottom-nav-more" },
];

export default function BottomNav() {
  return (
    <>
      {/* Bottom spacer so content isn't hidden behind the fixed nav */}
      <div className="h-20 pb-[env(safe-area-inset-bottom)]" aria-hidden="true" />

      <nav
        data-testid="event-bottom-nav"
        className="fixed bottom-0 inset-x-0 z-40 border-t border-white/5 bg-emerald-950/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)] shadow-[0_-8px_32px_-8px_rgba(0,0,0,0.35)]"
      >
        <ul className="mx-auto max-w-lg grid grid-cols-5 items-end">
          {items.map(({ to, icon: Icon, label, testid, end, primary }) => (
            <li key={to} className="flex justify-center">
              <NavLink
                to={to}
                end={end}
                data-testid={testid}
                className={({ isActive }) =>
                  [
                    "flex flex-col items-center gap-1 py-2.5 px-2 min-w-[56px] text-[11px] font-[Outfit] font-semibold tracking-wide transition-all",
                    primary ? "-mt-6" : "",
                    isActive
                      ? "text-fuchsia-300"
                      : "text-white/60 hover:text-white",
                  ].join(" ")
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={
                        primary
                          ? `h-14 w-14 rounded-full flex items-center justify-center ring-4 ring-emerald-950 transition-transform bg-fuchsia-500 text-white ${
                              isActive
                                ? "scale-105 shadow-[0_16px_40px_-8px_rgba(217,70,239,0.7)]"
                                : "shadow-[0_10px_28px_-8px_rgba(217,70,239,0.55)]"
                            }`
                          : `h-8 w-8 rounded-full flex items-center justify-center transition-colors ${
                              isActive ? "bg-white text-emerald-950" : "bg-transparent"
                            }`
                      }
                    >
                      <Icon size={primary ? 26 : 18} strokeWidth={primary ? 2.4 : 2} />
                    </span>
                    <span className="leading-none">{label}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
